import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import {Form} from "react-final-form";
import ApiZoneSelectField from "../../../FinalForm/api/ApiZoneSelectField";
import {apiGetZone, apiPostZone} from "./Actions";
import ZoneTariffPriceList from "./ZoneTariffPriceList";
import arrayMutators from "final-form-arrays";
import {FiSave} from "react-icons/fi";
import {FilterButton} from "../components/Button";
import {FormCard} from "../components/FormCard";

const ZoneForm = () => {
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);
    let user = useSelector((state) => state.user);

    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetZone(user.activeAreal.id, id, (data) => {
                let newData = data;
                if (data?.tariffs) {
                    newData.selectedTariff = data.tariffs.map(t => t.tariffId);
                }
                if (data?.parentZone) {
                    newData.parentZone = data.parentZone.id;
                }
                setData(newData);
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/zone/list");
            });
        }
    };

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o zóně.\n";
        switch (err.data) {
            case "ZONE_NOT_FOUND":
                error += "Zóna nebyla nalezena.";
                break;
            case "UNKNOWN_ERROR":
            default:
                error += "Neznámá chyba.";
        }
        Toast.error(error);
    };

    const onSubmit = (values) => {
        if (!user?.user?.rights?.enigooTurniketsEdit) return;
        setSaving(true);
        let newValues = {...values, selectedTariff: undefined};
        apiPostZone(user.activeAreal.id, id ? id : null, newValues, (data) => {
            let newData = data;
            if (data?.tariffs) {
                newData.selectedTariff = data.tariffs.map(t => t.tariffId);
            }
            if (data?.parentZone) {
                newData.parentZone = data.parentZone.id;
            }
            setData(newData);
            setSaving(false);
            navigate("/zone/detail/" + data.id);
            Toast.success("Úspěšně uloženo.");
        }, (err) => {
            setSaving(false);
            handleError(err);
        });
    };

    return (
        <>
            <PageHeader crumbs={[{label: "Zóny", to: "/zone/list"}, {label: id ? "Upravit zónu" : "Vytvořit zónu"}]}/>

            {loading ? <DefaultLoader text={"Načítám data zóny..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                      mutators={{...arrayMutators}}
                      render={({handleSubmit, values, form: {mutators: {push}}}) => (
                          <>
                              <FormCard>
                                  <InputField label={"Název (25)"} name={"name"} isMandatory={true} inputType={"text"}/>
                                  <div
                                      className={"widget w-full p-4 mt-4 rounded-lg bg-blue-100 border border-grey-100"}>
                                      <p><span className="font-bold underline">Typ zóny</span></p>
                                      <p><span className="font-bold">Podle vstupenky</span> - sleduje
                                          konkrétní vstupenku v zóně (vstup/výstup, kapacita dle počtu vstupenek
                                          uvnitř).</p>
                                      <p><span className="font-bold">Počítadlo průchodů</span> - jen sčítá průchody bez vazby na konkrétní vstupenku,
                                          kapacita se počítá z tohoto součtu.</p>
                                      <p><span className="font-bold">Nevyplněno</span> - chová se stejně jako "Podle vstupenky"</p>
                                  </div>
                                  <SelectField label={"Typ zóny"} name={"type"} isMandatory={false} options={[
                                      {label: "Podle vstupenky", value: "REAL_TICKET_COUNTER"},
                                      {label: "Počítadlo průchodů", value: "ENTRANCE_COUNTER"}
                                  ]}/>
                                  <InputField label={"Kapacita zóny"} name={"capacity"} isMandatory={false}
                                              inputType={"number"}/>
                                  <InputField label={"Časový limit v zóně"} name={"timeLimit"} isMandatory={false}
                                              inputType={"number"}/>
                                  <ApiZoneSelectField isMulti={false} label={"Nadřazená zóna"} name={"parentZoneId"}/>
                                  <ZoneTariffPriceList values={values} push={push}/>
                              </FormCard>
                              {user?.user?.rights?.enigooTurniketsEdit && (
                                  <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit"
                                                icon={<FiSave size={12}/>} fullWidth/>
                              )}
                          </>
                      )}
                />
            )}
        </>
    );
};
export default ZoneForm;
